module.exports = __webpack_public_path__ + "static/media/arlenfan.d1e20f10.jpg";